/**
 * Schema violations.
 *
 * @type {String}
 */

export const CHILD_OBJECT_INVALID = 'child_object_invalid'
export const CHILD_REQUIRED = 'child_required'
export const CHILD_TYPE_INVALID = 'child_type_invalid'
export const CHILD_UNKNOWN = 'child_unknown'
export const FIRST_CHILD_OBJECT_INVALID = 'first_child_object_invalid'
export const FIRST_CHILD_TYPE_INVALID = 'first_child_type_invalid'
export const LAST_CHILD_OBJECT_INVALID = 'last_child_object_invalid'
export const LAST_CHILD_TYPE_INVALID = 'last_child_type_invalid'
export const NEXT_SIBLING_OBJECT_INVALID = 'next_sibling_object_invalid'
export const NEXT_SIBLING_TYPE_INVALID = 'next_sibling_type_invalid'
export const NODE_DATA_INVALID = 'node_data_invalid'
export const NODE_IS_VOID_INVALID = 'node_is_void_invalid'
export const NODE_MARK_INVALID = 'node_mark_invalid'
export const NODE_OBJECT_INVALID = 'node_object_invalid'
export const NODE_TEXT_INVALID = 'node_text_invalid'
export const NODE_TYPE_INVALID = 'node_type_invalid'
export const PARENT_OBJECT_INVALID = 'parent_object_invalid'
export const PARENT_TYPE_INVALID = 'parent_type_invalid'
export const PREVIOUS_SIBLING_OBJECT_INVALID = 'previous_sibling_object_invalid'
export const PREVIOUS_SIBLING_TYPE_INVALID = 'previous_sibling_type_invalid'
